import type { PropsWithChildren } from 'react'

import { Button } from '@features/common.components/Button'
import { Link } from '@features/common.components/Link'
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid'
import classNames from 'classnames'

export interface ActionCardProps extends PropsWithChildren {
  title: string
  actions: { label: string; path: string; type: 'console' | 'external' }[]
}

export const ActionCard: React.FC<ActionCardProps> = ({
  children,
  title,
  actions,
}) => {
  return (
    <div className="py-2">
      <div className="rounded-lg border border-black-75 px-8 py-6">
        <div className="flex flex-row items-center">
          <div className="mb-1 text-xl text-neutral-strong font-circular-medium">
            {title}
          </div>
        </div>
        <div className="text-neutral-subtle">{children}</div>
        <div
          className={classNames('space-x-2', {
            'mt-4': actions.length > 0,
          })}
        >
          {actions.map((action) => (
            <Link key={action.label} path={action.path} type={action.type}>
              <Button variant="primary">
                <div className="flex items-center justify-center space-x-2">
                  <div>{action.label}</div>
                  <div>
                    <ArrowTopRightOnSquareIcon className="size-6" />
                  </div>
                </div>
              </Button>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
